"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceStringVars = void 0;

var replaceStringVars = function replaceStringVars(string, vars) {
  return Object.keys(vars).reduce(function (acc, key) {
    if (key) {
      var re = new RegExp("{{".concat(key, "}}"), 'g');
      return acc.replace(re, String(vars[key]));
    }

    return acc;
  }, string);
};

exports.replaceStringVars = replaceStringVars;